"use client";

import React from "react";
import { PiArrowLeft } from "react-icons/pi";
import { useRouter } from "next/navigation";

type CheckoutHeaderProps = {
  text: string;
};

export const CheckoutHeader = ({ text }: CheckoutHeaderProps) => {
  const { back } = useRouter();

  return (
    <header className="relative flex items-center justify-center bg-white px-4 py-3">
      <button
        className="absolute left-2 rounded-xl p-2 text-body-contrast transition-colors sm:left-20"
        onClick={back}
      >
        <PiArrowLeft size={24} />
      </button>
      <p>{text}</p>
    </header>
  );
};
